import { getScreenBreakpoints, getScreenWidth, getItemHeight, setItemHeight, resetItemHeight } from "./screen";
import { initContainerSlider, resetContainerSlider } from './sliders';

window.cga2026_script_vars = window.cga2026_script_vars || {};

const handleTabClick = ( target, items ) => {
	items.forEach( item => {
		if ( item.classList.contains( 'cga-panel-active' ) ) {
			item.classList.add( 'cga-panel-about-inactive' );
			setTimeout( () => {
				item.classList.remove( 'cga-panel-active', 'cga-panel-about-inactive' );
			}, 350 );
		}
	});
	
	const tabsContainer = target.closest( '.cga-accordion-tabs' );
	if ( tabsContainer !== null ) {
		const prevTarget = tabsContainer.querySelector( '.cga-accordion-tab-item.active' );
		if ( prevTarget !== null ) {
			prevTarget.classList.remove( 'active' );
		}
	}

	target.classList.add( 'active' );
	const dest = document.querySelector( `#${target.dataset.id}` );
	if ( dest !== null ) {
		const item = dest.closest( '.wp-block-accordion-item' );
		item.classList.add( 'cga-panel-active' );
		item.classList.remove( 'cga-panel-about-inactive' );
	}
};

const initAccordionPanel = ( container ) => {
	container.classList.add( 'accordion-initialized' );

	const accordionCont = container.querySelector( '.wp-block-accordion' );
	const panels = container.querySelectorAll( '.wp-block-accordion-panel' );
	if ( panels.length < 2 ) {
		return;
	}

	const items = container.querySelectorAll( '.wp-block-accordion-item' );
	if ( items.length < 2 ) {
		return;
	}

	let itemHeight = getItemHeight( panels );
	if ( itemHeight > 0 ) {
		itemHeight += 64;
		setItemHeight( [ accordionCont ], itemHeight );
		// Also accordion panels
		setItemHeight( panels, itemHeight );
	}	

	items.forEach( item => {
		item.style.cssText = 'position: absolute; top: 0; left: 0; right: 0; transform: translateX( 100vw )';
		item.classList.remove( 'cga-panel-active' );
		item.querySelector( '.wp-block-accordion-panel' ).removeAttribute( 'hidden' );
	});
	items[ 0 ].classList.add( 'cga-panel-active' );

	const headings = container.querySelectorAll( '.wp-block-accordion-heading' );

	const tabs = document.createElement( 'div' );
	tabs.classList.add( 'cga-accordion-tabs' );
	
	container.prepend( tabs );

	headings.forEach( heading => {
		const id = heading.querySelector( '.wp-block-accordion-heading__toggle' ).id;
		const title = heading.querySelector( '.wp-block-accordion-heading__toggle-title' ).innerText;
		const el = document.createElement( 'div' );
		el.classList.add( 'cga-accordion-tab-item' );
		if ( heading.parentElement.classList.contains( 'cga-panel-active' ) ) {
			el.classList.add( 'active' );
		}
		el.setAttribute( 'data-id', id );
		el.addEventListener( 'click', ( ev ) => {
			ev.preventDefault();
			handleTabClick( ev.currentTarget, items );
		} )
		const span = document.createElement( 'span' );
		span.innerHTML = title;
		el.appendChild( span );
		tabs.appendChild( el );
	});

	accordionCont.classList.add( 'displayed-as-tabbed-panels' );
};

const initAccordionSlider = ( container ) => {
	window.cga_accordion_slider_id = window.cga_accordion_slider_id || 0;
	window.cga_accordion_sliders = window.cga_accordions || {};

	const accordionCont = container.querySelector( '.wp-block-accordion' );
	const items = container.querySelectorAll( '.wp-block-accordion-item' );
	if ( items.length < 2 ) {
		return;
	}

	window.cga_accordion_slider_id++;
	accordionCont.setAttribute( 'data-accordion', window.cga_accordion_slider_id );

	window.addEventListener( 'cga.slider.initialized', ( ev ) => {
		// Make sure all accordion panels are opened
		items.forEach( item => {
			const panel = item.querySelector( '.wp-block-accordion-panel' );
			if ( panel !== null ) {
				panel.removeAttribute( 'hidden' );
			}
		});

		window.cga_accordion_sliders[ window.cga_accordion_slider_id ] = ev.detail;
	});

	initContainerSlider( accordionCont, items );
};

const resetTabbedAccordion = ( container ) => {
	container.classList.remove( 'accordion-initialized' );
	const accordionCont = container.querySelector( '.wp-block-accordion' );
	const panels = container.querySelectorAll( '.wp-block-accordion-panel' );
	if ( panels.length < 2 ) {
		return;
	}

	const items = container.querySelectorAll( '.wp-block-accordion-item' );
	if ( items.length < 2 ) {
		return;
	}

	resetItemHeight( panels );
	resetItemHeight( [ accordionCont ] );

	const tabs = container.querySelector( '.cga-accordion-tabs' );
	if ( tabs !== null ) {
		tabs.remove();
	}

	items.forEach( item => {
		item.style.cssText = 'position: unset; top: unset; left: unset; right: unset; transform: unset )';
		item.classList.remove( 'cga-panel-active' );
	});

	accordionCont.classList.remove( 'displayed-as-tabbed-panels' );
};

const resetAccordionSlider = ( container ) => {
	const accordionCont = container.querySelector( '.wp-block-accordion' );
	const items = container.querySelectorAll( '.wp-block-accordion-item' );

	const accordionSliderId = accordionCont.dataset.accordion;

	resetContainerSlider( accordionCont, items );
	if ( accordionSliderId > 0 ) {
		if ( typeof window.cga_accordion_sliders[ accordionSliderId ] !== 'undefined' ) {
			if ( typeof window.resetCgaSlider !== 'undefined' ) {
				window.resetCgaSlider( window.cga_accordion_sliders[ accordionSliderId ].container, window.cga_accordion_sliders[ accordionSliderId ].key );
			}
		}

		delete window.cga_accordion_sliders[ accordionSliderId ];
	}
};

const resetCGAAccordions = () => {
	const containers = document.querySelectorAll( '.cga-accordions-container.tabbed-panel' );
	if ( containers.length < 1 ) {
		return;
	}

	containers.forEach( container => {
		resetTabbedAccordion( container );
		resetAccordionSlider( container );
	});
};

const initCGAAccordions = () => {
	const containers = document.querySelectorAll( '.cga-accordions-container.tabbed-panel' );
	if ( containers.length < 1 ) {
		return;
	}

	containers.forEach( container => {
		if ( container.classList.contains( 'mobile-as-accordion-sliders' ) && ( getScreenWidth() <= getScreenBreakpoints( 'lg' ) ) ) {
			initAccordionSlider( container );
		} else {
			initAccordionPanel( container );
		}
	});
};

export { initCGAAccordions, resetCGAAccordions };